import { Component, OnInit, Input } from '@angular/core';

import { camps } from '../../../../models/models.generated';
import { campsenum } from '../../../../models/enums.generated';
import { CampsEnumTranslationService } from '../../../../services/camps-enum-translation.service';


@Component({
    selector: 'app-payment-details',
    templateUrl: './payment-details.component.html',
    styleUrls: ['./payment-details.component.scss'],
    standalone: false
})
export class PaymentDetailsComponent implements OnInit {

    @Input()
    public purchase: camps.CampPurchaseDetails;

    constructor(private enumTranslations: CampsEnumTranslationService) { }

    ngOnInit() {
    }

    public get isRefunded():boolean{
        if(!this.purchase)
            return false;

        return campsenum.CampPurchaseStatus[this.purchase.status] == campsenum.CampPurchaseStatus.Refunded;
    }

    public isCCPayment(payment: camps.PurchasePaymentDetails): boolean{
        return payment.paymentMethod === campsenum.PaymentMethod.CreditCard;
    }
    
    public isDCPayment(payment: camps.PurchasePaymentDetails): boolean{
        return payment.paymentMethod === campsenum.PaymentMethod.DebitCard;
    }

    public isGiftCard(payment: camps.PurchasePaymentDetails): boolean{
        return payment.paymentMethod === campsenum.PaymentMethod.GiftCard;
    }

    public translatePaymentMethod(paymentMethod: campsenum.PaymentMethod) {
        return this.enumTranslations.paymentMethod(paymentMethod);
    }
}
